export default {
  cmpId: '10-04358',
  cmpName: 'residential_realtordirectory',
  cmpPosition: 'residential_resultlist',
  cmpCreative: 'touchpoint_standard',
};
